import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from "ngx-cookie-service";
import { Subject } from "rxjs";
import { shareReplay } from 'rxjs/operators';
import { ApiService } from "src/app/services/api";
import { AlertService } from './../../AlertService/alert.service';
@Injectable({
  providedIn: "root",
})
export class JobTypeService {
  storeId = this.cookieService.get("storeId");
  merchantId = this.cookieService.get("merchantId");
  isLoadingChangeSub = new Subject<boolean>();

  GLOBALURL: String = this.ApiService.getBaseURL()
  token = this.cookieService.get("token");
  constructor(
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private toastr: AlertService,
    private ApiService: ApiService,
    private modalService: NgbModal,
  ) {

    this.GLOBALURL = this.ApiService.getBaseURL()

  }

  getJobTypes() {
    return this.http.get(this.GLOBALURL + "/jobtype", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params: new HttpParams()
        .set("storeId", this.storeId)
        .set("merchantId", this.merchantId),
    }).pipe(shareReplay(1));
  }

  getAllJobTypes(params?:any) {
    return this.http.get(this.GLOBALURL + "/jobtype", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params:new HttpParams()
        .set("storeId", this.storeId)
        // .set("merchantId", this.merchantId)
        // .set("limit", 0)
        .set("offset", 0),
    }).pipe(shareReplay(1));
  }

  getEmployeeJobTypes(empId) {
    return this.http.get(this.GLOBALURL + "/employeeJobtype/query", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params: new HttpParams()
        .set("employeeId", empId)
        .set("merchantId", this.merchantId)
        .set("storeId", this.storeId)


    }).pipe(shareReplay(1));
  }

  getJobTypeById(id) {
    return this.http.get(this.GLOBALURL + "/jobtype", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params: new HttpParams()
        .set("storeId", this.storeId)
        .set("merchantId", this.merchantId)
        .set("jobtypeId",id)
    }).pipe(shareReplay(1));
  }

  getNextJobTypes(offset: number) {
    return this.http.get(this.GLOBALURL + "/jobtype", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
      params: new HttpParams()
        .set("storeId", this.storeId)
        .set("merchantId", this.merchantId)
        .set("offset", offset),
    }).pipe(shareReplay(1));
  }

  addJobType(payload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .post(this.GLOBALURL + "/jobtype", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.error(response.message);
            this.isLoadingChangeSub.next(false);
          } else {
            if (this.modalService.hasOpenModals()) {
              console.log("MODAL_OPEN");
              this.isLoadingChangeSub.next(false);
              const department = response.response;
              this.modalService.dismissAll( department );
              this.toastr.clear();
              this.toastr.success(response.message);
              return
            }
            setTimeout(() => this.toastr.success(response.message), 500);
            this.isLoadingChangeSub.next(false);
            this.router.navigate(["/employees/jobtypes"]);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
          this.isLoadingChangeSub.next(false);
        }
      );
  }

  updateJobType(payload) {
    // this.isLoadingChangeSub.next(true);
    return this.http
      .put(this.GLOBALURL + "/jobtype", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.error(response.message);
            // this.isLoadingChangeSub.next(false);
          } else {
            this.toastr.success(response.message);
            // this.isLoadingChangeSub.next(false);
            // this.router.navigate(["/employees/jobtypes"]);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
          // this.isLoadingChangeSub.next(false);
        }
      );
  }
}
